@if (transmitter) {
  <app-product-card
    [product]="transmitter!"
    [showCosts]="showCosts"
    [selectionMode]="isSelectable ? 'single' : 'none'"
    [isSelected]="isSelected"
    (select$)="select(transmitter)"
  >
    @if (transmitter.id) {
      <div class="feature">
        <p class="p-label odx-text--small" i18n="@@global.partNumber">Sachnummer</p>
        <p class="odx-text--small">{{ transmitter.id }}</p>
      </div>
    }
    @if (dimensionsProperty) {
      <div class="feature">
        <p class="p-label odx-text--small" i18n="@@transmitterConfiguration.transmitterCard.dimensions.header">
          Abmessungen (H x B x T)
        </p>
        <p class="odx-text--small" i18n="@@transmitterConfiguration.transmitterCard.dimensions">
          ({{ dimensionsProperty.height * 1000 }}mm × {{ dimensionsProperty.width * 1000 }}mm ×
          {{ dimensionsProperty.depth * 1000 }}mm)
        </p>
      </div>
    }
    @if (displayProperty) {
      <div class="feature" odxLayout="flex">
        @if (displayProperty.value) {
          <odx-icon name="check" inline></odx-icon>
        }
        @if (!displayProperty.value) {
          <odx-icon name="close" class="icon-red" inline></odx-icon>
        }
        <p i18n="@@transmitterConfiguration.transmitterCard.displayProperty">Display</p>
      </div>
    }
    @if (flameproofProperty) {
      <div class="feature" odxLayout="flex">
        @if (flameproofProperty.value) {
          <odx-icon name="check" inline></odx-icon>
        }
        @if (!flameproofProperty.value) {
          <odx-icon name="close" class="icon-red" inline></odx-icon>
        }
        <p i18n="@@transmitterConfiguration.transmitterCard.flameproofProperty">Druckfest gekapselt</p>
      </div>
    }
    @if (wirelessProperty) {
      <div class="feature" odxLayout="flex">
        @if (wirelessProperty.value) {
          <odx-icon name="check" inline></odx-icon>
        }
        @if (!wirelessProperty.value) {
          <odx-icon name="close" class="icon-red" inline></odx-icon>
        }
        <p i18n="@@transmitterConfiguration.transmitterCard.wirelessProperty">Wireless</p>
      </div>
    }
    @if (productInfoUrl) {
      <div class="link-row" odxLayout="flex">
        <a odxLink class="card-link" [href]="productInfoUrl" target="_blank" (click)="$event.stopPropagation()">
          <odx-icon name="document" inline></odx-icon>
          <span i18n="@@global.productDatasheet">Produktdatenblatt</span>
        </a>
      </div>
    }
  </app-product-card>
}
